import React from 'react'
import { ReactComponent as Close } from "../assets/icons/x.svg";
import NewButton from './NewButton';
import { FileUploaderButton } from '../Components/FileUploaderButton';


const AddfilesPopUpModel = ({ onCancel = () => { }, onClose = () => { }, onSave = () => { }, files, handleFiles, handleDeleteFile, windowSize }) => {

  return (
    <div className='newPopUpModalWrap'>
      <div className="newPopUpModalContainer max-w-xl items-center relative">
        <h2 className="newPopUpModalTitle">Uploade Files</h2>
        <Close className="newPopUpModalCloseIcon" onClick={onClose} />

        <div className='w-full'>
          <FileUploaderButton hideAddComment display text="Choose Files" files={files} handleFiles={handleFiles} handleDeleteFile={handleDeleteFile} fontSize={windowSize.width > 1024 ? 1.1 : windowSize.width > 767 ? (windowSize.orientation === 'portrait' ? 1.6 : 1.1) : (windowSize.orientation === 'portrait' ? 5 : 1.5)} />
        </div>
        <div className='w-full flex gap-4 '>
          <NewButton width='100%' text={"Cancel"} back={true} icon={false} whiteBtn={true} onClick={onCancel} />
          <NewButton
            width='100%'
            text={"Save"}
            disabled={files.length === 0 || files.some(el => el.status !== "complete")}
            onClick={onSave}
          />
        </div>
      </div>
    </div>
  )
}

export default AddfilesPopUpModel
